import { databases } from "@/lib/appwrite";
import { getMonthlyWorkSessions, type WorkSession } from "../report";
import { Query } from "appwrite";


const DB = import.meta.env.VITE_APPWRITE_DATABASE_ID!;
const SESSIONS_NOTES_COL = import.meta.env.VITE_WORK_SESSION_NOTES_COLLECTION_ID!;
const WORK_BREAKS_COL = import.meta.env.VITE_WORK_BREAKS_COLLECTION_ID!;

export interface WorkSessionNote {
    $id: string;
    sessionId: string;
    noteContent: string;
    createdAt: string;
}

export interface WorkBreak {
    $id: string;
    workSessionId: string;
    startTime: string;
    endTime?: string;
    location?: string;
    breakDuration: number;
}

export interface WorkSessionDetailed extends WorkSession {
    notes: WorkSessionNote[];
    breaks: WorkBreak[];
}


export async function getMonthlyWorkSessionsDetailed(
    userId: string,
    year: number,
    month: number
): Promise<WorkSessionDetailed[]> {
    //traer las sesiones basicas
    const sessions = await getMonthlyWorkSessions(userId, year, month);

    // definir el  rango ISO para el filtro (1er día 00:00:00 – último día 23:59:59)
    const ecuadorStartDate = new Date(year, month - 1, 1, 0, 0, 0, 0);
    const ecuadorEndDate = new Date(year, month, 0, 23, 59, 59, 999);
    const start = new Date(ecuadorStartDate.getTime() + (5 * 60 * 60 * 1000)).toISOString();
    const end = new Date(ecuadorEndDate.getTime() + (5 * 60 * 60 * 1000)).toISOString();
    // consultar todas las notas de sesión de ese mes

    const notesResponse = await databases.listDocuments(DB, SESSIONS_NOTES_COL, [
        Query.equal("userId", userId),
        Query.greaterThanEqual("createdAt", start),
        Query.lessThanEqual("createdAt", end),
    ]);
    const allNotes = notesResponse.documents as unknown as WorkSessionNote[];

    //consultar todos los breaks de ese mes
    const breaksResponse = await databases.listDocuments(DB, WORK_BREAKS_COL, [
        Query.equal("userId", userId),
        Query.greaterThanEqual("startTime", start),
        Query.lessThanEqual("startTime", end),
    ]);
    const allBreaks = breaksResponse.documents as unknown as WorkBreak[];

    //agrupar notas y breaks por sesión
    return sessions.map(s => ({
        ...s,
        notes: allNotes.filter(n => n.sessionId === s.$id),
        breaks: allBreaks.filter(b => b.workSessionId === s.$id),
    }));
}
